import * as types from "./types";
import { combineReducers } from "redux";
import orderBy from "lodash/orderBy";

function listadoBajas(state = [], { type, payload }) {
  return type === types.FETCH_LISTADO_BAJAS
    ? orderBy(payload, ["fechaBaja"], ["desc"])
    : type === types.RESET_LISTADO_BAJAS
      ? []
      : state;
}

const reducer = combineReducers({
  listadoBajas
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/listados/reducers.js